import { render, staticRenderFns } from "./RejectRechargeWithdraw.vue?vue&type=template&id=3b97d632&scoped=true&"
import script from "./RejectRechargeWithdraw.vue?vue&type=script&lang=js&"
export * from "./RejectRechargeWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./RejectRechargeWithdraw.vue?vue&type=style&index=0&id=3b97d632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b97d632",
  null
  
)

export default component.exports